function buildTempHumidityFromLiveStats(dataArr) {
  let result = []
  let previousValidValues = {
    temp: null,
    humidity: null
  }

  if (!dataArr || !dataArr.length) {
    return []
  }
  
  for (let i = 0; i < dataArr.length; i++) {
    let relevantDataArr = []
    relevantDataArr.push(dataArr[i].datetime) // Index 0 will hold datetime

    // Temperature from sen5x
    let temp = parseFloat(dataArr[i].tstat_read_data.sen5x?.temp || 0)
    if (temp === 0 && previousValidValues.temp !== null) {
      temp = previousValidValues.temp
    }
    if (temp !== 0) {
      previousValidValues.temp = temp
    }
    relevantDataArr.push(temp)

    // Humidity from sen5x
    let humidity = parseFloat(dataArr[i].tstat_read_data.sen5x?.rh || 0)
    if (humidity === 0 && previousValidValues.humidity !== null) {
      humidity = previousValidValues.humidity
    }
    if (humidity !== 0) {
      previousValidValues.humidity = humidity
    }
    relevantDataArr.push(humidity)

    result.push(relevantDataArr)
  }

  return result
}

function formatTempHumidityData(dataArr) {
  const chartData = dataArr.map((dataItem) => {
    return [
      new Date(dataItem[0]),           // Datetime
      dataItem[1],          // Temperature
      dataItem[2]           // Humidity
    ]
  })

  return chartData
}

export {
  buildTempHumidityFromLiveStats,
  formatTempHumidityData
}